export const GET_ENG_QUOTA_BURN_LIST = "GET_ENG_QUOTA_BURN_LIST"
export const GET_ENG_QUOTA_BURN_LIST_SUCCESS = "GET_ENG_QUOTA_BURN_LIST_SUCCESS"
export const GET_ENG_QUOTA_BURN_LIST_FAIL = "GET_ENG_QUOTA_BURN_LIST_FAIL"

export const ENG_QUOTA_BURN_APPROVED = "ENG_QUOTA_BURN_APPROVED"
export const ENG_QUOTA_BURN_APPROVED_SUCCESS = "ENG_QUOTA_BURN_APPROVED_SUCCESS"
export const ENG_QUOTA_BURN_APPROVED_FAIL = "ENG_QUOTA_BURN_APPROVED_FAIL"

export const ENG_QUOTA_BURN_UPDATE = "ENG_QUOTA_BURN_UPDATE"
export const ENG_QUOTA_BURN_UPDATE_SUCCESS = "ENG_QUOTA_BURN_UPDATE_SUCCESS"
export const ENG_QUOTA_BURN_UPDATE_FAIL = "ENG_QUOTA_BURN_UPDATE_FAIL"



export const RESET_ENG_QUOTA = "RESET_ENG_QUOTA"
export const RESET_QUOTA = "RESET_QUOTA"
